<template>
  <div>
    <div v-if="loading">Cargando datos...</div>
    <div v-else>
      <b-row>
        <b-col sm="6" md="6" xl="6">
          <b-form-group label="Proveedor" label-for="localProviderId">
            <v-select
                v-model="localProviderId"
                class="pt-0"
                label="provider"
                name="localProviderId"
                :reduce="(option) => option.id"
                :disabled="disabled || loading"
                :options="providersAll"
            />
            <small v-if="validation" class="text-danger">
              {{ validation }}
            </small>
          </b-form-group>
        </b-col>

        <b-col sm="6" md="6" xl="6">
          <b-form-group label="CIF" label-for="cif">
            <b-form-input
                v-model="cif"
                name="cif"
                placeholder="CIF"
                :disabled="true"
                :class="validation ? 'is-invalid' : ''"
            />
          </b-form-group>
        </b-col>

        <b-col sm="6" md="6" xl="4">
          <b-form-group label="Contacto Principal" label-for="contact_primary">
            <b-form-input
                v-model="contact_primary"
                name="contact_primary"
                placeholder="Contacto Principal"
                :disabled="true"
                :class="validation ? 'is-invalid' : ''"
            />
          </b-form-group>
        </b-col>

        <b-col sm="6" md="6" xl="4">
          <b-form-group label="Email" label-for="email">
            <b-form-input
                v-model="email"
                name="email"
                placeholder="Email"
                :disabled="true"
                :class="validation ? 'is-invalid' : ''"
            />
          </b-form-group>
        </b-col>

        <b-col sm="6" md="6" xl="4">
          <b-form-group label="Teléfono" label-for="phone">
            <b-form-input
                v-model="phone"
                name="phone"
                placeholder="Teléfono"
                :disabled="true"
                :class="validation ? 'is-invalid' : ''"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { BFormGroup, BFormInput, BRow, BCol } from "bootstrap-vue"
import vSelect from "vue-select"

export default {
  components: {
    vSelect,
    BFormGroup,
    BRow,
    BCol,
    BFormInput
  },
  props: {
    providerId: {
      type: Number,
      default: null
    },
    providersAll: {
      type: Array,
      default: () => []
    },
    validation: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: true,
      localProviderId: this.providerId,
      cif: "",
      contact_primary: "",
      email: "",
      phone: ""
    }
  },
  watch: {
    localProviderId(newId) {
      this.localProviderId = newId
      this.$emit('update', { provider_id: this.localProviderId })
      const selectedProvider = this.getProviderById(newId)
      if (selectedProvider) {
        this.cif = selectedProvider.cif || ""
        this.contact_primary = selectedProvider.contact_primary || ""
        this.email = selectedProvider.email || ""
        this.phone = selectedProvider.phone_24 || ""
      } else {
        this.cif = ""
        this.contact_primary = ""
        this.email = ""
        this.phone = ""
      }
    },
    providersAll: {
      handler(newProviders) {
        this.loading = false
        if (this.localProviderId && newProviders.length > 0) {
          const selectedProvider = this.getProviderById(this.localProviderId)
          if (selectedProvider) {
            this.cif = selectedProvider.cif || ""
            this.contact_primary = selectedProvider.contact_primary || ""
            this.email = selectedProvider.email || ""
            this.phone = selectedProvider.phone_24 || ""
          }
        }
      },
      immediate: true
    }
  },
  mounted() {
    if (this.localProviderId && this.providersAll.length > 0) {
      const selectedProvider = this.getProviderById(this.localProviderId)
      if (selectedProvider) {
        this.cif = selectedProvider.cif || ""
        this.contact_primary = selectedProvider.contact_primary || ""
        this.email = selectedProvider.email || ""
        this.phone = selectedProvider.phone_24 || ""
      }
    }
  },
  methods: {
    getProviderById(id) {
      if (!Array.isArray(this.providersAll)) return null
      return this.providersAll.find(provider => provider?.id === id) || null
    }
  }
}
</script>
